<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { kenwoodItalyBasicMixin } from "../../modules/kenwood_italy_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, kenwoodItalyBasicMixin],
  mounted() { },
  methods: {
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getContentURL: Fandom.getContentURL,
  },
  computed: {}
}
</script>

<template>
  <div v-easyadmin="easyadminId" :id="`ref-${easyadminId}`" :class="contentType" page-thankyou>
   <div class="page-thankyou__header mb-4" :style="{'background-image': getBackgroundUrl(content.header_image.url)}">
     <div class="container">
       <div class="row align-items-center page-thankyou__header__row">
         <div class="col-12 col-md-6">
           <component class="title-composed" :is="content.title_tag || 'h2'" v-if="content.title">
             {{content.title}}
           </component>
           <div class="title-composed" v-else>
             <h2 v-for="title in content.title_composed" :class="getTitleStyle(title)">
               {{title.title}}
             </h2>
           </div>
           <p v-html="content.description" v-if="content.description"></p>
         </div>
       </div>
     </div>
   </div>
   <div class="container mb-4" v-if="content.thankyou_box" :style="{'background-color': content.thankyou_box.background_color}">
     <div class="row justify-content-center">
       <div class="col-12 col-md-10">
         <div class="page-thankyou__box">
           <div class="page-thankyou__box__icon mx-auto mb-3">
             <svg>
               <use :xlink:href="'#thankyou'"></use>
             </svg>
           </div>
           <p class="page-thankyou__box__title h4 text-orange" v-html="content.thankyou_box.title"></p>
           <p class="page-thankyou__box__description" v-html="content.thankyou_box.description"></p>
         </div>
       </div>
     </div>
   </div>
   <component :is="stripe.layout" :content="stripe" v-for="stripe in content.stripes" :key="stripe.$id" :opt-container-content="containerContent"></component>
  </div>
</template>

<style lang="scss" scoped>
[page-thankyou] {
  .page-thankyou__header {
    background-size: cover;
    background-position: center;
    
    .page-thankyou__header__row {
      min-height: 55vh;
    }
  }
  
  .page-thankyou__box {
    text-align: center;
    padding: 3rem;
    @include media-breakpoint-down(sm) {
      padding: 3rem 0;
    }
  }
  
  .page-thankyou__box__icon {
    width: 93px;
    height: 93px;
    margin: 0 auto;
  }
  
  .page-thankyou__box__title {
    font-family: $bressay-font;
  }
  
  .page-thankyou__box__description {
    font-family: $bressay-font;
    font-size: 2rem; /* 32/16 */
    margin: 0;
    padding-bottom: 2rem;
  }
}
</style>